// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbarOverlay {
  border: 2px solid var(--ui-border-color-dark);
  padding: 5px;
}
.tooltip-toolbar-overlay {
  margin-top: 40px;
  background-color: var(--primary-background-color);
  border: 1px solid var(--default-color);
  border-radius: 8px;
}
.tooltip-toolbar-overlay .tooltip-arrow {
  display: none;
}
.tooltip-toolbar-overlay .tooltip-inner {
  max-width: unset;
  background: none;
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-break: auto;
  line-height: 1.42857143;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  white-space: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  font-size: 12px;
  opacity: 0;
}
.tooltip.in {
  opacity: 0.9;
}
.tooltip.top {
  margin-top: -3px;
  padding: 5px 0;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.right {
  margin-left: 3px;
  padding: 0 5px;
}
.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}
.tooltip.bottom {
  margin-top: 3px;
  padding: 5px 0;
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.left {
  margin-left: -3px;
  padding: 0 5px;
}
.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}
.tooltip.top-left .tooltip-arrow {
  bottom: 0;
  right: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  left: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  right: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  left: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/toolbarButton/ExpandableToolMenu.styl"],"names":[],"mappings":"AAAA;EACE,6CAAO;EACP,YAAQ;AACV;AACA;EACE,gBAAW;EACX,iDAAkB;EAClB,sCAAQ;EACR,kBAAe;AACjB;AACE;EACE,aAAQ;AACZ;AAAE;EACE,gBAAW;EACX,gBAAY;AAEhB;AAAA;EACE,kBAAU;EACV,aAAS;EACT,cAAS;EACT,kBAAY;EACZ,mBAAa;EACb,sBAAgB;EAChB,gBAAY;EACZ,uBAAa;EACb,gBAAY;EACZ,iBAAY;EACZ,qBAAiB;EACjB,iBAAa;EACb,oBAAgB;EAChB,mBAAa;EACb,kBAAY;EACZ,oBAAc;EACd,iBAAW;EACX,eAAW;EACX,UAAS;AAEX;AAAE;EACE,YAAS;AAEb;AAAE;EACE,gBAAY;EACZ,cAAS;AAEb;AAAI;EACE,SAAQ;EACR,SAAM;EACN,iBAAa;EACb,uBAAc;EACd,sBAAkB;AAExB;AAAE;EACE,gBAAa;EACb,cAAS;AAEb;AAAI;EACE,QAAK;EACL,OAAM;EACN,gBAAY;EACZ,2BAAc;EACd,wBAAoB;AAE1B;AAAE;EACE,eAAY;EACZ,cAAS;AAEb;AAAI;EACE,MAAK;EACL,SAAM;EACN,iBAAa;EACb,uBAAc;EACd,yBAAqB;AAE3B;AAAE;EACE,iBAAa;EACb,cAAS;AAEb;AAAI;EACE,QAAK;EACL,QAAO;EACP,gBAAY;EACZ,2BAAc;EACd,uBAAmB;AAEzB;AAAE;EACE,SAAQ;EACR,UAAO;EACP,mBAAe;EACf,uBAAc;EACd,sBAAkB;AAEtB;AAAE;EACE,SAAQ;EACR,SAAM;EACN,mBAAe;EACf,uBAAc;EACd,sBAAkB;AAEtB;AAAE;EACE,MAAK;EACL,UAAO;EACP,gBAAY;EACZ,uBAAc;EACd,yBAAqB;AAEzB;AAAE;EACE,MAAK;EACL,SAAM;EACN,gBAAY;EACZ,uBAAc;EACd,yBAAqB;AAEzB;AAAA;EACE,gBAAW;EACX,gBAAS;EACT,WAAO;EACP,kBAAY;EACZ,sBAAkB;EAClB,kBAAe;AAEjB;AAAA;EACE,kBAAU;EACV,QAAO;EACP,SAAQ;EACR,yBAAc;EACd,mBAAc;AAEhB;AAAA;EACE,UAAS;EACT,wCAAoB;EACpB,mCAAe;EACf,gCAAY;AAEd;AAAA;EACE,UAAS;AAEX","sourcesContent":[".toolbarOverlay\n  border 2px solid var(--ui-border-color-dark)\n  padding 5px\n\n.tooltip-toolbar-overlay\n  margin-top 40px\n  background-color: var(--primary-background-color);\n  border: 1px solid var(--default-color);\n  border-radius: 8px;\n\n  .tooltip-arrow\n    display none\n  .tooltip-inner\n    max-width: unset\n    background: none\n\n.tooltip\n  position: absolute\n  z-index: 1070\n  display: block\n  font-style: normal\n  font-weight: normal\n  letter-spacing: normal\n  line-break: auto\n  line-height: 1.42857143\n  text-align: left\n  text-align: start\n  text-decoration: none\n  text-shadow: none\n  text-transform: none\n  white-space: normal\n  word-break: normal\n  word-spacing: normal\n  word-wrap: normal\n  font-size: 12px\n  opacity: 0\n\n  &.in\n    opacity: 0.9\n\n  &.top\n    margin-top: -3px\n    padding: 5px 0\n\n    .tooltip-arrow\n      bottom: 0\n      left: 50%\n      margin-left: -5px\n      border-width: 5px 5px 0\n      border-top-color: #000\n\n  &.right\n    margin-left: 3px\n    padding: 0 5px\n\n    .tooltip-arrow\n      top: 50%\n      left: 0\n      margin-top: -5px\n      border-width: 5px 5px 5px 0\n      border-right-color: #000\n\n  &.bottom\n    margin-top: 3px\n    padding: 5px 0\n\n    .tooltip-arrow\n      top: 0\n      left: 50%\n      margin-left: -5px\n      border-width: 0 5px 5px\n      border-bottom-color: #000\n\n  &.left\n    margin-left: -3px\n    padding: 0 5px\n\n    .tooltip-arrow\n      top: 50%\n      right: 0\n      margin-top: -5px\n      border-width: 5px 0 5px 5px\n      border-left-color: #000\n\n  &.top-left .tooltip-arrow\n    bottom: 0\n    right: 5px\n    margin-bottom: -5px\n    border-width: 5px 5px 0\n    border-top-color: #000\n\n  &.top-right .tooltip-arrow\n    bottom: 0\n    left: 5px\n    margin-bottom: -5px\n    border-width: 5px 5px 0\n    border-top-color: #000\n\n  &.bottom-left .tooltip-arrow\n    top: 0\n    right: 5px\n    margin-top: -5px\n    border-width: 0 5px 5px\n    border-bottom-color: #000\n\n  &.bottom-right .tooltip-arrow\n    top: 0\n    left: 5px\n    margin-top: -5px\n    border-width: 0 5px 5px\n    border-bottom-color: #000\n\n.tooltip-inner\n  max-width: 200px\n  padding: 3px 8px\n  color: #fff\n  text-align: center\n  background-color: #000\n  border-radius: 4px\n\n.tooltip-arrow\n  position: absolute\n  width: 0\n  height: 0\n  border-color: transparent\n  border-style: solid\n\n.fade\n  opacity: 0\n  -webkit-transition: opacity 0.15s linear\n  -o-transition: opacity 0.15s linear\n  transition: opacity 0.15s linear\n\n.fade.in\n  opacity: 1\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
